// extracted by mini-css-extract-plugin
export default {"description-block":"HeroImageBusinessLines_description-block__CSkmo","descriptionTextContainer":"HeroImageBusinessLines_descriptionTextContainer__R+tCi"};